import React, {useCallback} from 'react';
import I18n from 'app/i18n';
import {switchLanguage} from 'app/utils/langs/switchLanguage';
import logoUrl from 'images/landing-affiliates/logo.svg';
import {PARTNER_LOGIN_URL, PARTNER_REGISTER_URL} from './affiliatesLinks';

const AffiliatesHeader = (): React.ReactElement => {
    const lang = I18n.locale;

    const handleEnglish = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        switchLanguage(event.nativeEvent, 'en');
    }, []);

    const handleRussian = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        switchLanguage(event.nativeEvent, 'ru');
    }, []);

    return <header className="hdr">
        <div className="wrap">
            <a className="logo" href="#top" aria-label="EGB Affiliates">
                <img src={logoUrl} alt="EGB Affiliates"/>
            </a>
            <div className="lang" role="group" aria-label={I18n.t('affiliate.eyebrow')}>
                <button type="button" aria-pressed={lang === 'en'} onClick={handleEnglish}>EN</button>
                <button type="button" aria-pressed={lang === 'ru'} onClick={handleRussian}>RU</button>
            </div>
            <a className="signin" href={PARTNER_LOGIN_URL}>{I18n.t('affiliate.signin')}</a>
            <a className="btn btn-sm" href={PARTNER_REGISTER_URL}>{I18n.t('affiliate.join')}</a>
        </div>
    </header>;
};

export default AffiliatesHeader;
